import {connect} from "react-redux";
import { Outlet } from "react-router-dom";

const Messages_Left = (props) => {
    return(
        <div className={`messages_rooms messages_rooms_${props.color_background}`}>
            <Outlet />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Messages_Left);